import type { DataMode } from '@infra/licence/ActivationClaims';
import { NexxusDatabase } from '@infra/persistence/NexxusDatabase';
import { BusinessApiClient, getBusinessApiClient } from '@infra/api/BusinessApiClient';
import { logger } from '@infra/telemetry/Logger';
import { isLocalOfflineMode } from '@infra/licence/DataModeResolver';
import type { IPersistencePort } from '@infra/persistence/IPersistencePort';
import { LocalRepositoriesAdapter } from './LocalRepositoriesAdapter';
import { SqliteLocalRepositoriesAdapter } from './SqliteLocalRepositoriesAdapter';
import { RemoteRepositoriesAdapter } from './RemoteRepositoriesAdapter';

let sharedBusinessApi: BusinessApiClient | null = null;

function businessApi(): BusinessApiClient {
  if (!sharedBusinessApi) sharedBusinessApi = getBusinessApiClient();
  return sharedBusinessApi;
}

/** Sélectionne l’adapter de persistance selon le mode signé dans la licence. */
export class RepositoryFactory {
  static async create(
    dataMode: DataMode,
    db: NexxusDatabase,
    tenantId = 'default',
  ): Promise<IPersistencePort> {
    if (isLocalOfflineMode(dataMode)) {
      if (await SqliteLocalRepositoriesAdapter.isActive()) {
        logger.info({ event: 'persistence_adapter', mode: 'LOCAL_OFFLINE', engine: 'sqlite' });
        return new SqliteLocalRepositoriesAdapter();
      }
      logger.info({ event: 'persistence_adapter', mode: 'LOCAL_OFFLINE', engine: 'dexie' });
      return new LocalRepositoriesAdapter(db);
    }
    logger.info({ event: 'persistence_adapter', mode: 'REMOTE_MULTI_STATION', offlineCache: true });
    return RemoteRepositoriesAdapter.create(businessApi(), tenantId);
  }
}

/** Accès test / remplacement du client API métier. */
export function setBusinessApiClientForTests(client: BusinessApiClient | null): void {
  sharedBusinessApi = client;
}
